// extracted by mini-css-extract-plugin
export default {"pizzaLoader":"Loader_pizzaLoader__M8RCm"};